var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { RestServiceBase } from "@ane/core/lib/services/RestServiceBase";
import { onError } from "@ane/core/lib/decorators/OnError";
import logger from "@ane/core/lib/services/logging/Logger";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
import { WPSProxyConverter } from "@ane/core/lib/services/WPSProxy";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let ForayRunnerResources = class extends RestServiceBase {
  constructor() {
    super(EnvironmentService.endpoints.legacy);
  }
  validateForayJobConfig(forayValidationRequest) {
    return __async(this, null, function* () {
      logger.log(`ValidateForayJobConfig called with ForayValidation request Id ${forayValidationRequest.Id}`);
      const result = yield this._post(
        forayValidationRequest,
        `/api/forayrunner/foray/validationReportRest`
      );
      return result;
    });
  }
};
__decorateClass([
  onError({ message: `An error occurred while getting Sample foray job config` })
], ForayRunnerResources.prototype, "validateForayJobConfig", 1);
ForayRunnerResources = __decorateClass([
  WPSProxyConverter()
], ForayRunnerResources);
const ForayRunnerResources$1 = new ForayRunnerResources();
export {
  ForayRunnerResources,
  ForayRunnerResources$1 as default
};
//# sourceMappingURL=ForayRunnerResources.js.map
